import { Box, Button, Heading } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  Button,
  Heading,
  React
};